"use strict";

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ExportClassCode =
/*#__PURE__*/
function () {
  function ExportClassCode(path) {
    _classCallCheck(this, ExportClassCode);

    this.m_Path = path;
  }

  _createClass(ExportClassCode, [{
    key: "AddMember",
    value: function AddMember(member) {
      this.m_Members.push(member);
    }
  }, {
    key: "m_Code",
    get: function get() {
      return this.m_Path.node;
    }
  }, {
    key: "m_Class",
    get: function get() {
      return this.m_Code.declaration;
    }
  }, {
    key: "m_Members",
    get: function get() {
      return this.m_Class.body.body;
    }
  }, {
    key: "m_Name",
    get: function get() {
      return this.m_Class.id.name;
    }
  }]);

  return ExportClassCode;
}();

exports.ExportClassCode = ExportClassCode;